import { Box, Divider } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useStore, withStore } from '@data/other/withStore';
import BEImageList from '@molecules/BEImageList';
import { useModal } from '@molecules/BEOffScreen';
import Text from '@molecules/Text';
import Gallery from '@view/components/Modals/Gallery';
import AddressAndContact from './components/AddressAndContact';
import AmenityList from '@view/molecules/AmenitiesList';
import Policies from './components/Policies';
import Description from './components/Description';
import { PropertyInfoContainer, Wrapper } from './StyledPropertyInfo';
import TermsAndConditions from './components/TermsAndConditions';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const PropertyInfo = () => {
  const { t } = useTranslation();
  const { property } = useStore();
  const { model } = property;

  const galleryImages = useMemo(() => model?.images || [], [model]);

  const galleryModal = useModal(Gallery, {});
  const handleOpenGalleryModal = (index?: number) => {
    galleryModal.open({
      index,
      images: model?.images || [],
    });
  };

  return (
    <Wrapper>
      {model && (
        <PropertyInfoContainer mb="40px">
          <Box className="card-body">
            <Text type="h1">{t('property-information')}</Text>
            {galleryImages.length > 0 && (
              <Box className="gallery">
                <BEImageList
                  gap={16}
                  images={galleryImages.map((image) => image.thumb)}
                  onClickItem={handleOpenGalleryModal}
                  showDots={false}
                />
              </Box>
            )}
            {model.description?.getText() && (
              <>
                <Description description={property.description || ''} />
              </>
            )}
            {model?.amenities && model?.amenities.length > 0 && (
              <>
                <Divider className="divider" />
                <Text type="h2">{t('properties-and-amenities')}</Text>
                <AmenityList
                  amenities={property.propertyFeatures || []}
                  additionalAmenities={
                    property.propertyAdditionalFeatures || []
                  }
                  rows={4}
                  viewAll={true}
                />
              </>
            )}
            {model?.address && (
              <>
                <Divider className="divider" />
                <AddressAndContact model={model} />
              </>
            )}
            {model?.policies && (
              <>
                <Divider className="divider" />
                <Policies model={model} />
              </>
            )}
            {model?.termsAndConditions?.getText() && (
              <>
                <Divider className="divider" />
                <TermsAndConditions terms={property.termsAndConditions || ''} />
              </>
            )}
          </Box>
        </PropertyInfoContainer>
      )}
    </Wrapper>
  );
};

export default withStore(observer(PropertyInfo));
